var _regionSeoContent$blo;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { StoreProvider, createAppState } from '../store/store';
import Search from '../layouts/search/Search';
var container = document.getElementById('app');
var _window$appModel = window['appModel'],
  search = _window$appModel.search,
  config = _window$appModel.config,
  gacOverAllInfo = _window$appModel.gacOverAllInfo,
  tracking = _window$appModel.tracking,
  seoData = _window$appModel.seoData,
  teaserData = _window$appModel.teaserData,
  regionSeoContent = _window$appModel.regionSeoContent;
var preloadedState = createAppState({
  search: _objectSpread({}, search),
  config: _objectSpread({}, config),
  gacOverAllInfo: _objectSpread({}, gacOverAllInfo),
  tracking: _objectSpread({}, tracking),
  seoData: _objectSpread({}, seoData),
  teaserData: _objectSpread({}, teaserData),
  regionSeoContent: {
    blocks: (_regionSeoContent$blo = regionSeoContent === null || regionSeoContent === void 0 ? void 0 : regionSeoContent.blocks) !== null && _regionSeoContent$blo !== void 0 ? _regionSeoContent$blo : []
  }
});
if (container) {
  hydrateRoot(container, /*#__PURE__*/React.createElement(StoreProvider, {
    initialState: preloadedState
  }, /*#__PURE__*/React.createElement(Search, null)));
} else {
  console.error('Could not find DOM element with id "app"');
}